<template>
  <LayoutCard
    :href="href"
    :target="target"
    :class="[
      'related-card',
      { 'related-card--link': !!href },
    ]"
  >
    <template #head>
      <UiMediaImage
        :image="cover"
        :masked="true"
        :fit="true"
        :ratio="16/9"
        width="910"
        class="related-card__image"
      />
    </template>

    <template v-if="label" #overlay>
      <UiTag :label="label" />
    </template>

    <template #body>
      <p class="related-card__name typo-h3">
        {{ name }}
      </p>
    </template>
  </LayoutCard>
</template>

<script>
import { Media } from '~/data/media';

export default {
  props: {
    cover: { type: Media, default: null },
    name: { type: String, default: null },
    label: { type: String, default: null },
    href: { type: String, default: null },
    target: { type: String, default: '_self' },
  },
};
</script>

<style lang="stylus" scoped>
card-color-animation('.related-card', '.related-card__name')

.related-card {
  text-align left
  transition background-color 0.2s

  &:hover {
    background-color var(--theme-color, white)
  }
}

.related-card__image {
  aspect-ratio 16/9
}

.related-card__name {
  margin-top 25px
}

:deep(.card-layout__overlay) {
  bottom 20px
  left 20px
}
</style>
